import React, {ReactNode} from 'react';
import cn from 'classnames';

import Button from 'shared/ui/Button/Button/Button';
import Plus from 'shared/ui/icons/Plus';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';

import styles from './CreateEntityButton.module.scss';

interface ICreateEntityButtonProps {
    ariaLabel: string,
    onClick: () => void,
    disabled?: boolean,
    className?: string,
    children: ReactNode,
}

const CreateEntityButton: React.FC<ICreateEntityButtonProps> = ({
    ariaLabel,
    onClick,
    disabled,
    className,
    children,
}) => {
    const breakpoint = useBreakpoint();

    const iconSize = breakpoint === 'small' || breakpoint === 'mini' ? 45 : 24;

    return (
        <Button
            variant="gradient"
            onClick={onClick}
            aria-label={ariaLabel}
            className={cn(styles.button, disabled && styles.disabled, className)}
            disabled={disabled}
        >
            <Plus width={iconSize} height={iconSize}/>
            {children}
        </Button>
    );
};

export default CreateEntityButton;
